export const ADD_CODES: { [key: string]: string } = {
  "02": "Type 2 reassignment",
  "03": "Type 3 reassignment",
  "25": "Miscellaneous Add",
  "6B": "PVD",
  "70": "Temporary Flight Supervisor",
  "72": "Temporary CA",
  AF: "Reassignment",
  AG: "Aggressive Pick-Up - Reserve",
  AH: "Aggressive Pick-Up - Lineholder - Pay Only",
  AL: "Aggressive Pick-Up - Lineholder - Pay and Credit",
  AP: "Apportionment Pay",
  AR: "Cross Division Reserve Assignment",
  AU: "Cross Division Reserve Assignment - Unconfirmed",
  CD: "CKA Proficiency Displacement",
  CF: "Civil Reserve Air Fleet (CRAF)",
  CH: "Changeover Sequence",
  CK: "Check Pilot Added",
  CO: "DOTC Conflict",
  CP: "RO Conflict on Footprint - Pay no credit",
  DF: "RO Sequence Drop on Footprint - Pay no credit",
  DL: "Restricted Duty",
  DM: "Restricted Duty Maternity",
  DP: "Displacement",
  DT: "Displacement For IOE",
  EA: "Early Award/Assignment",
  FM: "RO Out of Base Pickup on Footprint",
  FT: "Full Sequence adds following post-fatigue rest",
  GO: "Greater of Pick-up with conflict",
  HY: "Hybrid day assignment - Pay no credit",
  IE: "Initial Operating Experience",
  IH: "Partial Paid Injury On Duty",
  IR: "International Reassignment",
  JM: "Junior Reserve Assignment",
  JU: "Unconfirmed Junior Reserve Assignment",
  LQ: "Low on time qualification",
  LR: "Cross Division Junior Reserve Assignment",
  LU: "Cross Division Junior Reserve Assignment, Unconfirmed",
  LT: "Low on time",
  MF: "Management Flying",
  MM: "Pickup flying over maximum",
  MN: "RO Pickup on Footprint - Pay no credit",
  MO: "Pickup flying out of base",
  MU: "Pickup Flying",
  OD: "Reserve Flying - Flown into DFP before 1200 HBT",
  OF: "RO Open Time Pickup on Footprint - Pay no credit",
  OV: "Observation Ride",
  OG: "Reserve Over Guarantee",
  OM: "Over Maximum Reassignment",
  OT: "Trip Trade With Open Time",
  PC: "Check Pilot Proficiency",
  PD: "Consolidation Flying",
  PF: "RO Sequence Pickup on Footprint - Pay no credit",
  PM: "Premium Flying",
  PP: "Reserve Pay Protection",
  PR: "Premium Flying, Reserve",
  PU: "Paid Union Leave",
  PX: "Permanent Transfer, Paid",
  QI: "Qualification Illegality",
  RA: "Reassignment",
  RD: "Replacement of DFP",
  RF: "Reserve Preference Flying",
  RO: "Recovery Obligation",
  RP: "Report",
  RS: "Reschedule",
  RU: "Reserve Preference Flying - Unconfirmed",
  SD: "Sequence Add TTOT",
  SH: "Schedule Change",
  SR: "Original Pilot Who Shared Trip",
  SP: "Straight Pickup TTOT",
  SW: "Pilot Receiving a Shared Trip",
  TF: "RO Over VMAX Pickup on Footprint",
  TP: "RO Trip Trade on Footprint",
  TT: "Trip Trade",
  TR: "Transitional Reserve Day",
  TV: "Trip Trade over VMAX",
  VA: "PVD Hurricane",
  VD: "Reserve Flying - DFP Volunteer",
  W6: "Wings PVD",
  WG: "Wings",
  XC: "Schedule Conflict",
  XM: "EOM conflict; Confirmed Reserve",
  XU: "EOM Conflict; Unconfirmed Reserve",
  YM: "EOM Conflict; Confirmed Cross Division Reserve",
  YU: "EOM Conflict; Unconfirmed Cross Division Reserve",
};
